const _getPersistedMenu = (state: EntireFrontendState) =>
  state.cachedMenu || { cachedMenu: null };

export default _getPersistedMenu;
